import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useCommonStyles } from "../../utils";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import KeyboardReturnRoundedIcon from "@mui/icons-material/KeyboardReturnRounded";

const CommonTextField = ({
  size,
  placeholder,
  name,
  value,
  label,
  multiline,
  rows,
  label2,
  color,
  onClick,
  isEmail,
  isPassword,
  isAdd,
  type,
  onChange,
  onKeyDown,
  backgroundColor,
  onEnterClick,
  isReadOnly,
  mb,
  error,
  width,
  textAlign,
  isCurrency,
  currencyValue,
  border,
  disabled,
  sx,
  labelColor,
  fontWeight,
  fontSize,
  fontFamily,
  marginBottom,
  valid,
}) => {
  const { classes } = useCommonStyles();

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      {label &&
        <Box display="flex" justifyContent="space-between">
          {label && (
            <Box display={"flex"} gap={'2px'}>
              <InputLabel
                className={classes.label}
                sx={{
                  fontWeight: fontWeight ? fontWeight : "500",
                  fontSize: fontSize ? fontSize : "14px",
                  fontFamily: "Satoshi-Medium",
                  color: labelColor || "#2E2E30",
                  marginBottom: marginBottom || "8px",
                  textTransform: "capitalize",
                }}
              >
                {label}
              </InputLabel>
              {valid && (
                <Typography height={'5px'} color="#EF627A" component={"caption"} variant={"body2"}>
                  *
                </Typography>
              )}
            </Box>
          )}
          {label2 && (
            <InputLabel
              className={classes.label}
              onClick={onClick}
              // sx={{ color: color ? color : "#131313", cursor: "pointer" }}
              sx={{
                fontWeight: fontWeight ? fontWeight : "500",
                fontSize: fontSize ? fontSize : "14px",
                fontFamily: "Satoshi-Medium",
                color: color || "#131313",
                marginBottom: marginBottom || "8px",
                textTransform: "capitalize",
                cursor: "pointer",
              }}
            >
              {label2}
            </InputLabel>
          )}
        </Box>
      }
      <TextField
        error={error}
        type={showPassword ? "text" : type}
        multiline={multiline}
        disabled={disabled ? true : false}
        className={classes.field}
        sx={{
          ...sx,
          "& .MuiOutlinedInput-root": {
            backgroundColor: backgroundColor ? backgroundColor : "transparent",
            mb: mb ? mb : 0,
            width: width ? width : "100%",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: border || "1px solid rgba(19, 19, 19, 0.20)",
          },
          "& input": {
            textAlign: textAlign ? textAlign : "left",
          },
        }}
        name={name}
        value={value}
        size={size || "small"}
        variant="outlined"
        placeholder={placeholder}
        rows={rows}
        onChange={onChange}
        onKeyDown={onKeyDown}
        InputProps={{
          startAdornment: isCurrency ? (
            <InputAdornment position="end"
              sx={{
                // marginLeft: "35px",
                // marginRight: "-40px",
              }}
            >{currencyValue}</InputAdornment>
          ) : null,
          endAdornment: isEmail ? (
            <InputAdornment position="end">
              <IconButton edge="end" sx={{ cursor: "auto" }}>
                <EmailOutlinedIcon sx={{ fill: "#8D8181" }} />
              </IconButton>
            </InputAdornment>
          ) : isPassword ? (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
              >
                {showPassword ? (
                  <RemoveRedEyeOutlinedIcon sx={{ fill: "#8D8181" }} />
                ) : (
                  <VisibilityOffOutlinedIcon sx={{ fill: "#8D8181" }} />
                )}
              </IconButton>
            </InputAdornment>
          ) : isAdd ? (
            <>
              <Button
                variant="contained"
                endIcon={<KeyboardReturnRoundedIcon sx={{ fill: "#FFFFFF" }} />}
                onClick={onEnterClick}
                sx={{
                  color: "#FFFFFF",
                  boxShadow: "none",
                  backgroundColor: "#E77843",
                  borderRadius: "30px",
                  padding: "2px 20px",
                  fontSize: "14px",
                  fontWeight: 700,
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "#E77843",
                    boxShadow: "none",
                  },
                }}
              >
                Enter
              </Button>
            </>
          ) : null,
        }}
      />
    </div>
  );
};

export default CommonTextField;
